import { html } from "lit";

export const newsTeaserData = {
    linkUrl: "#",
    iconName: "",
    label: "news",
    date: "17/06/2024",
    fullSize: false,
    variant: "default",
};

export const newsTeaserDataList = [
    {
        ...newsTeaserData,
    },
    {
        ...newsTeaserData,
        variant: "info-news",
    },
    {
        ...newsTeaserData,
        date: "18/06/2024",
    },
    {
        ...newsTeaserData,
        variant: "info-news",
    },
];

export const TeaserNewsTemplate = (args) => html`
    <ux-iws-link-wrapper>
        <div
            class="ux-iws-teaser-news ${args.variant === "info-news"
                ? "ux-iws-teaser-news--info-news"
                : ""}"
        >
            ${args.variant === "info-news"
                ? html`<div class="ux-iws-teaser-news__icon-container">
                      <ux-icon name="info-rounded"></ux-icon>
                  </div>`
                : html``}
            <div class="ux-iws-teaser-news__content">
                <span
                    class="ux-iws-teaser-news__info ux-text-small ux-text-small--bold"
                >
                    ${args.label} - ${args.date}
                </span>
                <ux-text-lines-limit
                    text-lines-s="5"
                    text-lines-m="3"
                    text-lines-l="4"
                    text-lines-xl="3"
                    nested-element-selector=".ux-iws-teaser-news__news-body"
                >
                    <p
                        class="ux-iws-teaser-news__news-content ux-text-normal ux-text-normal--light-gray"
                    >
                        <span
                            class="ux-iws-teaser-news__news-title ux-u-text-bold"
                        >
                            Wir sind für sie da!
                        </span>
                        <span class="ux-iws-teaser-news__news-body">
                            Lorem ipsum dolor sit amet, consetetur sadipscing
                            elitr, sed diam nonumy eirmod tempor invidunt ut
                            labore et dolore magna aliquyam erat, sed diam
                            voluptua. At vero eos et accusam et justo duo
                            dolores et ea rebum. Stet clita kasd gubergren, no
                            sea takimata sanctus est Lorem ipsum dolor sit amet.
                            Lorem ipsum dolor sit amet, consetetur sadipscing
                            elitr, sed diam nonumy eirmod tempor invidunt ut
                            labore et dolore magna aliquyam erat, sed diam
                            voluptua. At vero eos et accusam et justo duo
                            dolores et ea rebum. Stet clita kasd gubergren, no
                            sea takimata sanctus est Lorem ipsum dolor sit amet.
                            Lorem ipsum dolor sit amet, consetetur sadipscing
                            elitr, sed diam nonumy eirmod tempor invidunt ut
                            labore et dolore magna aliquyam erat, sed diam
                            voluptua. At vero eos et accusam et justo duo
                            dolores et ea rebum. Stet clita kasd gubergren, no
                            sea takimata sanctus est Lorem ipsum dolor sit amet.
                            Duis autem vel eum iriure dolor in hendrerit in
                            vulputate velit esse molestie consequat, vel illum
                            dolore eu feugiat nulla facilisis at vero eros et
                            accumsan et iusto odio dignissim qui blandit
                            praesent luptatum zzril delenit augue duis dolore te
                            feugait nulla facilisi. Lorem ipsum dolor sit amet,
                            consectetuer adipiscing elit, sed diam nonummy nibh
                            euismod tincidunt ut laoreet dolore magna aliquam
                            erat volutpat. Ut wisi enim ad minim veniam, quis
                            nostrud exerci tation ullamcorper suscipit lobortis
                            nisl ut aliquip ex ea commodo consequat. Duis autem
                            vel eum iriure dolor in hendrerit in vulputate velit
                            esse molestie consequat, vel illum dolore eu feugiat
                            nulla facilisis at vero eros et accumsan et iusto
                            odio dignissim qui blandit praesent luptatum zzril
                            delenit augue duis dolore te feugait nulla facilisi.
                            Nam liber tempor cum soluta nobis eleifend option
                            congue nihil imperdiet doming id quod mazim placerat
                            facer possim assum. Lorem ipsum dolor sit amet,
                            consectetuer adipiscing elit, sed diam nonummy nibh
                            euismod tincidunt ut laoreet dolore magna aliquam
                            erat volutpat. Ut wisi enim ad minim veniam, quis
                            nostrud exerci tation ullamcorper suscipit lobortis
                            nisl ut aliquip ex ea commodo consequat. Duis autem
                            vel eum iriure dolor in hendrerit in vulputate velit
                            esse molestie consequat, vel illum dolore eu feugiat
                            nulla facilisis. At vero eos et accusam et justo duo
                            dolores et ea rebum.
                        </span>
                    </p>
                </ux-text-lines-limit>
            </div>
            <div class="ux-iws-teaser-news__cta-container">
                <a
                    href="${args.linkUrl}"
                    class="ux-button ux-button--icon-only"
                    title="next"
                    aria-label="next"
                    role="button"
                >
                    <ux-icon name="chevron-right" />
                </a>
            </div>
        </div>
    </ux-iws-link-wrapper>
`;

export const TeaserNewsListTemplate = () => html`
    <div class="ux-iws-teaser-news-grid">
        <div class="ux-iws-teaser-news-grid__teaser-container">
            ${newsTeaserDataList.map((tile) => TeaserNewsTemplate(tile))}
        </div>
    </div>
`;
